
import React from 'react';
import { useArticleAI } from '@/contexts/article-ai/ArticleAIContext';
import ArticleKeyTakeaways from './ArticleKeyTakeaways';
import ArticleAskQuestion from './ArticleAskQuestion';
import ArticleAlternativePerspective from './ArticleAlternativePerspective';
import ArticleSimplify from './ArticleSimplify';

interface ArticleAIFeatureProps {
  article: any;
}

const ArticleAIFeature: React.FC<ArticleAIFeatureProps> = ({ article }) => {
  const { activeFeature } = useArticleAI();

  if (!activeFeature) return null;

  switch (activeFeature) {
    case 'takeaways':
      return <ArticleKeyTakeaways article={article} />;
    case 'ask':
      return <ArticleAskQuestion article={article} />;
    case 'perspective':
      return <ArticleAlternativePerspective article={article} />;
    case 'simplify':
      return <ArticleSimplify article={article} />;
    default:
      return null;
  }
};

export default ArticleAIFeature;
